import React from "react";
import PropTypes from "prop-types";
import { Checkbox, Radio as AntRadio } from "antd";
import { UiCheckboxer } from "./Checkboxer.style";
/**
 * checkbox / radio group
 */

const CheckGroup = Checkbox.Group;
const RadioGroup = AntRadio.Group;

const Checkboxer = ({
  label,
  options = [],
  value,
  onChange,
  disabled = false,
  className
}) => {
  const onChangeHandle = value => {
    onChange && onChange(value);
  };

  return /*#__PURE__*/React.createElement(UiCheckboxer, {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "group"
  }, /*#__PURE__*/React.createElement(CheckGroup, {
    onChange: onChangeHandle,
    disabled: disabled,
    value: value
  }, options.map((option, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "option",
      key: index
    }, /*#__PURE__*/React.createElement(Checkbox, {
      value: option.code
    }, option.name));
  }))));
};

export const Radio = ({
  label,
  options = [],
  value,
  onChange,
  disabled = false,
  className
}) => {
  const onChangeHandle = event => {
    onChange && onChange(event.target.value, event);
  };

  return /*#__PURE__*/React.createElement(UiCheckboxer, {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "group"
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    onChange: onChangeHandle,
    disabled: disabled,
    value: value
  }, options.map((option, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "option",
      key: index
    }, /*#__PURE__*/React.createElement(AntRadio, {
      value: option.code
    }, option.name));
  }))));
};
export default Checkboxer;
Checkboxer.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.array,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string
};
Radio.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string
};